import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DeleteAllFacebookInstagramData as DeleteAllFacebookInstagramDataMutation} from 'nutshell-graphql-types';

import DELETE_ALL_FACEBOOK_INSTAGRAM_DATA from '../mutations/delete-all-facebook-instagram-data.graphql';

export const useDeleteAllFacebookInstagramData = (): {
    deleteAllFacebookInstagramData: () => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteAllFacebookInstagramData, {loading, error}] = useMutation<
        DeleteAllFacebookInstagramDataMutation,
        Record<any, any>
    >(DELETE_ALL_FACEBOOK_INSTAGRAM_DATA);

    return {
        deleteAllFacebookInstagramData: () => {
            return deleteAllFacebookInstagramData();
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
